/* =========================================================
   Squishy Pop – effets spéciaux
   - [data-squish]       : s'écrase et rebondit comme de la gelée (ressort physique)
   - [data-squish-scope] : appuyer n'importe où dedans écrase son [data-squish]
   - [data-tilt]         : inclinaison 3D qui suit la souris + reflet lumineux
   - .sq-art             : les yeux du squishy suivent la souris et clignent
   - SquishyFX.fly(form) : le produit vole jusqu'au panier
   - SquishyFX.burst(x,y): pluie de confettis pastel
   ========================================================= */
(function () {
  'use strict';
  var html = document.documentElement;
  var enabled = html.classList.contains('fx');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var useTilt = html.dataset.fxTilt !== 'false';
  var useParticles = html.dataset.fxParticles !== 'false';
  var COLORS = ['#FFB3CB', '#9FD6F3', '#FFD85C', '#E8678F', '#FFFFFF', '#B8E3C9'];

  var api = {
    fly: function () { return Promise.resolve(); },
    burst: function () {},
    squish: function () {}
  };
  window.SquishyFX = api;
  if (!enabled || reduce) return;

  /* ---------- Ressort physique ---------- */
  var springs = new WeakMap();
  function Spring(el) {
    this.el = el; this.pos = 0; this.vel = 0; this.target = 0; this.running = false; this.last = 0;
    this.k = 420; this.c = 13;            // raideur / amortissement → rebond gélatineux
    this.ax = parseFloat(el.dataset.squishX || '0.17');
    this.ay = parseFloat(el.dataset.squishY || '0.22');
  }
  Spring.prototype.set = function (t) {
    this.target = t;
    if (!this.running) { this.running = true; this.last = performance.now(); this.el.style.transition = 'none'; requestAnimationFrame(this.tick.bind(this)); }
  };
  Spring.prototype.tick = function (now) {
    var dt = Math.min(0.032, (now - this.last) / 1000); this.last = now;
    var f = this.k * (this.target - this.pos) - this.c * this.vel;
    this.vel += f * dt; this.pos += this.vel * dt;
    var sx = 1 + this.pos * this.ax, sy = 1 - this.pos * this.ay;
    this.el.style.transform = 'scale(' + sx.toFixed(4) + ',' + sy.toFixed(4) + ')';
    if (Math.abs(this.target - this.pos) < 0.0015 && Math.abs(this.vel) < 0.002) {
      this.pos = this.target; this.vel = 0; this.running = false;
      if (this.target === 0) { this.el.style.transform = ''; this.el.style.transition = ''; }
      return;
    }
    requestAnimationFrame(this.tick.bind(this));
  };
  function springOf(el) { var s = springs.get(el); if (!s) { s = new Spring(el); springs.set(el, s); } return s; }
  function targetFrom(node) {
    if (!node || !node.closest) return null;
    var direct = node.closest('[data-squish]');
    if (direct) return direct;
    var scope = node.closest('[data-squish-scope]');
    return scope ? scope.querySelector('[data-squish]') : null;
  }
  function pulse(el, cb) {
    var s = springOf(el); s.set(1);
    setTimeout(function () { s.set(0); }, 120);
    if (cb) setTimeout(cb, 300);
  }
  api.squish = function (el) { if (el) pulse(el); };

  var pressed = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.button !== 0) return;
    var el = targetFrom(e.target);
    if (!el) return;
    pressed = el; springOf(el).set(1);
    if (el.hasAttribute('data-squish-burst')) { burst(e.clientX, e.clientY, 10); blink(el); }
    var hint = el.parentElement && el.parentElement.querySelector('.squish-hint');
    if (hint) hint.classList.add('is-gone');
  });
  ['pointerup', 'pointercancel'].forEach(function (t) {
    document.addEventListener(t, function () { if (pressed) { springOf(pressed).set(0); pressed = null; } });
  });
  document.addEventListener('pointerleave', function () { if (pressed) { springOf(pressed).set(0); pressed = null; } });

  // Clic sur un produit : petit « squish » avant d'ouvrir la page
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    if (a.target === '_blank' || a.closest('.card__quick')) return;
    var scope = a.closest('[data-squish-scope]');
    if (!scope) return;
    var el = scope.querySelector('[data-squish]');
    if (!el) return;
    e.preventDefault();
    if (e.detail === 0) pulse(el); // clavier
    setTimeout(function () { window.location.href = a.href; }, 260);
  });

  /* ---------- Inclinaison 3D ---------- */
  if (useTilt && finePointer) {
    document.querySelectorAll('[data-tilt]').forEach(function (el) {
      var max = parseFloat(el.dataset.tilt) || 8;
      var raf = 0, px = 0.5, py = 0.5;
      function apply() {
        raf = 0;
        el.style.transform = 'perspective(900px) rotateX(' + ((0.5 - py) * max * 2).toFixed(2) + 'deg) rotateY(' + ((px - 0.5) * max * 2).toFixed(2) + 'deg) translateZ(0)';
        el.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        el.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
      }
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        px = (e.clientX - r.left) / r.width; py = (e.clientY - r.top) / r.height;
        el.classList.add('is-tilting');
        if (!raf) raf = requestAnimationFrame(apply);
      });
      el.addEventListener('pointerleave', function () {
        el.classList.remove('is-tilting');
        el.style.transform = '';
        el.style.removeProperty('--gx'); el.style.removeProperty('--gy');
      });
    });
  }

  /* ---------- Yeux qui suivent + clignement ---------- */
  var arts = Array.prototype.slice.call(document.querySelectorAll('.sq-art'));
  if (arts.length) {
    var mx = -1, my = -1, eyeRaf = 0;
    var moveEyes = function () {
      eyeRaf = 0;
      arts.forEach(function (svg) {
        var r = svg.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var cx = r.left + r.width / 2, cy = r.top + r.height * 0.55;
        var dx = mx - cx, dy = my - cy, d = Math.hypot(dx, dy) || 1;
        var k = Math.min(1, d / 300) * 5;
        var g = svg.querySelector('.sq-eyes');
        if (g) g.style.transform = 'translate(' + (dx / d * k).toFixed(2) + 'px,' + (dy / d * k * 0.8).toFixed(2) + 'px)';
      });
    };
    window.addEventListener('pointermove', function (e) { mx = e.clientX; my = e.clientY; if (!eyeRaf) eyeRaf = requestAnimationFrame(moveEyes); }, { passive: true });
    (function loop() {
      setTimeout(function () {
        var svg = arts[Math.floor(Math.random() * arts.length)];
        blink(svg); loop();
      }, 2200 + Math.random() * 3000);
    })();
  }
  function blink(el) {
    var svg = el && (el.matches && el.matches('.sq-art') ? el : el.querySelector && el.querySelector('.sq-art'));
    if (!svg) return;
    svg.classList.remove('sq-blink'); void svg.getBoundingClientRect(); svg.classList.add('sq-blink');
    setTimeout(function () { svg.classList.remove('sq-blink'); }, 260);
  }

  /* ---------- Confettis ---------- */
  function burst(x, y, n) {
    if (!useParticles || !document.body.animate) return;
    n = n || 14;
    for (var i = 0; i < n; i++) {
      var p = document.createElement('span');
      var heart = Math.random() < 0.25;
      p.className = 'fx-particle ' + (heart ? 'fx-particle--heart' : 'fx-particle--blob');
      if (heart) p.textContent = '♥';
      var size = heart ? 12 + Math.random() * 10 : 7 + Math.random() * 9;
      p.style.setProperty('--s', size + 'px');
      p.style.setProperty('--c', COLORS[Math.floor(Math.random() * COLORS.length)]);
      document.body.appendChild(p);
      var ang = Math.random() * Math.PI * 2, dist = 50 + Math.random() * 90;
      var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist - 40;
      var rot = (Math.random() - 0.5) * 540;
      var anim = p.animate([
        { transform: 'translate(' + x + 'px,' + y + 'px) scale(.4) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + (x + dx) + 'px,' + (y + dy) + 'px) scale(1) rotate(' + rot / 2 + 'deg)', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + (x + dx * 1.2) + 'px,' + (y + dy + 70) + 'px) scale(.8) rotate(' + rot + 'deg)', opacity: 0 }
      ], { duration: 800 + Math.random() * 400, easing: 'cubic-bezier(.2,.7,.3,1)' });
      anim.onfinish = (function (el) { return function () { el.remove(); }; })(p);
    }
  }
  api.burst = burst;

  /* ---------- Vol vers le panier ---------- */
  api.fly = function (form) {
    return new Promise(function (resolve) {
      var cart = document.querySelector('[data-cart-open]');
      var scope = form && (form.closest('.card') || form.closest('.product'));
      var src = scope ? scope.querySelector('.card__media img, .card__media svg, [data-gallery-main] img, [data-gallery-main] svg') : null;
      if (!src) src = document.querySelector('[data-gallery-main] img, [data-gallery-main] svg');
      if (!cart || !src || !document.body.animate) { resolve(); return; }
      var a = src.getBoundingClientRect(), b = cart.getBoundingClientRect();
      if (!a.width) { resolve(); return; }
      var size = Math.min(a.width, a.height, 220);
      var fly = document.createElement('div');
      fly.className = 'fx-fly';
      fly.style.width = size + 'px'; fly.style.height = size + 'px';
      fly.style.left = '0px'; fly.style.top = '0px';
      fly.appendChild(src.cloneNode(true));
      document.body.appendChild(fly);
      var sx = a.left + (a.width - size) / 2, sy = a.top + (a.height - size) / 2;
      var ex = b.left + b.width / 2 - size / 2, ey = b.top + b.height / 2 - size / 2;
      var midX = (sx + ex) / 2, midY = Math.min(sy, ey) - 120;
      var anim = fly.animate([
        { transform: 'translate(' + sx + 'px,' + sy + 'px) scale(1)', borderRadius: '22px', opacity: 1 },
        { transform: 'translate(' + sx + 'px,' + sy + 'px) scale(1.12,.86)', offset: 0.12 },
        { transform: 'translate(' + midX + 'px,' + midY + 'px) scale(.55) rotate(-12deg)', borderRadius: '50%', offset: 0.55 },
        { transform: 'translate(' + ex + 'px,' + ey + 'px) scale(.12) rotate(10deg)', borderRadius: '50%', opacity: .6 }
      ], { duration: 820, easing: 'cubic-bezier(.45,0,.2,1)' });
      anim.onfinish = function () {
        fly.remove();
        cart.classList.remove('cart-bump'); void cart.offsetWidth; cart.classList.add('cart-bump');
        var count = cart.querySelector('[data-cart-count]');
        if (count) { count.classList.remove('is-pop'); void count.offsetWidth; count.classList.add('is-pop'); }
        burst(b.left + b.width / 2, b.top + b.height / 2, 12);
        setTimeout(resolve, 260);
      };
    });
  };

  /* ---------- Boutons en gelée ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.btn, .quick-btn, .chip');
    if (!b) return;
    b.classList.remove('is-jelly'); void b.offsetWidth; b.classList.add('is-jelly');
  });
  document.addEventListener('animationend', function (e) { if (e.animationName === 'jelly') e.target.classList.remove('is-jelly'); });

  /* ---------- Bulles dans la bannière ---------- */
  document.querySelectorAll('[data-bubbles]').forEach(function (box) {
    var n = parseInt(box.dataset.bubbles, 10) || 10;
    for (var i = 0; i < n; i++) {
      var b = document.createElement('i');
      b.style.left = (Math.random() * 100).toFixed(1) + '%';
      b.style.setProperty('--s', (8 + Math.random() * 22).toFixed(0) + 'px');
      b.style.setProperty('--d', (8 + Math.random() * 10).toFixed(1) + 's');
      b.style.setProperty('--delay', (-Math.random() * 12).toFixed(1) + 's');
      b.style.setProperty('--x', ((Math.random() - 0.5) * 120).toFixed(0) + 'px');
      box.appendChild(b);
    }
  });

  /* ---------- Apparition au défilement ---------- */
  if ('IntersectionObserver' in window) {
    var sel = '.section-head, .card, .tile, .step, .review, .value, .trust__item, .split__media, .split__body, .promo, .news, .faq details, .ugc__item, .cta-band';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    var vh = window.innerHeight;
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.closest('.cart-drawer, .search-modal, .sticky-atc')) return;
      if (el.getBoundingClientRect().top < vh * 0.95) return; // déjà visible : on ne cache rien
      var idx = Array.prototype.indexOf.call(el.parentElement.children, el) % 4;
      el.style.setProperty('--rd', (idx * 0.08) + 's');
      el.classList.add('fx-reveal');
      io.observe(el);
    });
  }
})();
